import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const c = content.contact || {};
  return (
    <footer data-testid="site-footer" className="bg-gray-950 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="mb-6">
            <img src="/logo-white.png" alt="Mountain Core Construction Group" className="h-14 w-auto" />
          </div>
          <p className="text-sm text-gray-400 max-w-sm leading-relaxed">
            Commercial construction built for business. Tenant improvements, buildouts, renovations, and
            facility upgrades, delivered on time and to spec.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gray-500 mb-4">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors duration-200" data-testid="footer-home">Home</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors duration-200" data-testid="footer-about">About</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors duration-200" data-testid="footer-services">Services</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors duration-200" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gray-500 mb-4">Get In Touch</p>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex items-center gap-3"><EnvelopeSimple size={18} className="text-gray-500" /> {c.email}</li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-gray-500" /> {c.phone}</li>
            <li className="flex items-center gap-3"><MapPin size={18} className="text-gray-500" /> {c.coverage}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-gray-500">
          <span>© 2024 Mountain Core Construction Group. All rights reserved.</span>
          <span>Licensed &amp; Insured Commercial Contractor</span>
        </div>
      </div>
    </footer>
  );
};
